import React, { Component } from 'react'

export default class RadioButton extends Component {

  render() {
    return (
      <div className="radio-container">
        <label className="radio-wrapper" htmlFor={`${this.props.name}_${this.props.value}_radio`}>
          <input
            className="radio-invisible-button"
            aria-describedby={this.props.ariaDescribedby}
            ref={this.props.radioRef}
            id={`${this.props.name}_${this.props.value}_radio`}
            name={this.props.name}
            onChange={this.props.onChange}
            value={this.props.value}
            type="radio"
            data-atid={`${this.props.dataAtId}_${this.props.value}_radio`}
          />
          <span className="radio-outer-circle" />
          {this.props.currentState === this.props.value && 
            <span className="radio-inner-circle" />
          }
          <span className="radio-label" tabIndex="-1" id={`${this.props.name}_${this.props.value}`}>{this.props.label}</span>
        </label>
      </div>
    )
  }
}